<template>
  <ul
    class="data-column"
    :class="[{ 'scroll-offset': scrollOffset }, { current: isCurrent }, { past: isPast }]"
  >
    <li class="hour">{{ hour }}</li>

    <li v-for="(item, i) in winds" :key="i" :class="item.level">
      <img :src="item.icon" alt="" class="risk-icon" />
      <span class="value">{{ round1Decimal(item.windSpeed) }}</span>

      <span v-if="item.temp" class="temp"> ({{ round1Decimal(item.temp) }}<span>℃</span>) </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { round1Decimal } from '@/utils/common'
defineProps<{
  hour: string
  winds: {
    windSpeed: number
    level?: 'warning' | 'danger'
    icon: string
    temp?: number
  }[]
  scrollOffset?: boolean
  isCurrent?: boolean
  isPast?: boolean
}>()
</script>
